var map = {
	"./logo-1.png": 1180,
	"./logo-10.png": 5670,
	"./logo-11.png": 3759,
	"./logo-12.png": 3844,
	"./logo-2.png": 8215,
	"./logo-3.png": 6078,
	"./logo-4.png": 641,
	"./logo-5.png": 8600,
	"./logo-6.png": 579,
	"./logo-7.png": 746,
	"./logo-8.png": 3629,
	"./logo-9.png": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 692;